import React, { Component } from 'react';
import { AnchorButton, Dialog, Classes, } from "@blueprintjs/core";
import * as dialogResults from '../../../constatns/dialogs';

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

    };
    this.KeyPressHandler = this.KeyPressHandler.bind(this);
    this.CancelClickHandler = this.CancelClickHandler.bind(this);
    this.OKClickHandler = this.OKClickHandler.bind(this);
    this.NoClickHandler = this.NoClickHandler.bind(this);
  }

  KeyPressHandler(e) {
    if (e.key === 'Enter') {
      if (this.props.showConfirm || this.props.showDisconfirm) {
        this.OKClickHandler();
      }
      else {
        this.CancelClickHandler();
      }
      e.stopPropagation();
    }
  }

  CancelClickHandler() {
    this.props.result(dialogResults.CANCEL);
  }

  OKClickHandler() {
    this.props.result(dialogResults.OK);
  }
  NoClickHandler() {
    this.props.result(dialogResults.NO);
  }
  render() {
    return (
      <Dialog
        icon={this.props.icon}
        onClose={this.CancelClickHandler}
        title={this.props.title}
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={false}
        enforceFocus={true}
        isOpen={this.props.show}
        usePortal={true}
        style={this.props.style}
        className={this.props.className}
      >
        <div className={Classes.DIALOG_BODY} style={this.props.bodyStyle}>
          {this.props.children}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            {(this.props.showConfirm || this.props.showDisconfirm) &&
              <AnchorButton className={Classes.INTENT_PRIMARY}
                data-tag={'Yes'}
                onClick={this.OKClickHandler}
                style={{ width: '90px' }}
              >
                {this.props.confirmName ? this.props.confirmName : "Yes"}
              </AnchorButton>}
            {this.props.showDisconfirm &&
              < AnchorButton
                data-tag={'No'}
                onClick={this.NoClickHandler}
                style={{ width: '90px' }}
              >
                {this.props.disconfirmName ? this.props.disconfirmName : "No"}
              </AnchorButton>}
            {this.props.showCancel&&
              <AnchorButton
                data-tag={'Cancel'}
                onClick={this.CancelClickHandler}
                style={{ width: '90px' }}
              >
                {this.props.closeName ? this.props.closeName : "Cancel"}
              </AnchorButton>
            }

          </div>
        </div>
      </Dialog >);
  }

}



export default ConfirmationModal;
